import React, { Component } from 'react';
import PropTypes from 'prop-types';

class ReadMoreText extends Component {
  constructor(props) {
    super(props);
    this.state = {
      expanded: false,
    };
  }

  UNSAFE_componentWillReceiveProps(nextProps) {
    if (nextProps !== this.props) {
      this.setState({ expanded: false });
    }
  }

  toggleText = () => {
    this.setState({ expanded: !this.state.expanded });
  }

  render() {
    const { text, length, wrapQuotes } = this.props;
    const quote = wrapQuotes ? '"' : '';

    if (text.length <= length) {
      return (
        <p className="mb-micro">
          {quote}
          {text}
          {quote}
        </p>
      );
    }

    let buttonText = 'Expand';
    let displayText = `${quote}${text.substring(0, length)}...${quote} `;

    if (this.state.expanded) {
      buttonText = 'Collapse';
      displayText = `${quote}${text}${quote}`;
    }
    return (
      <span>
        <p className="mb-micro">{displayText}</p>
        <a
          onClick={this.toggleText}
          className="blue fs-s"
          role="button"
          tabIndex="0"
        >
          {buttonText}
        </a>
      </span>
    );
  }
}

ReadMoreText.propTypes = {
  text: PropTypes.string.isRequired,
  length: PropTypes.number,
  wrapQuotes: PropTypes.bool,
};

ReadMoreText.defaultProps = {
  length: 280,
  wrapQuotes: false,
};

export default ReadMoreText;
